<script>
    import { createEventDispatcher } from "svelte";
    import Button from "./button.svelte";
    export let showModal = false;  
    export let sizeClass="modal-xl"; 
    export let zindex="1050";
    export let targetClass="";
    export let buttonText="Confirm";
    export let showConfirmButton=true;
    export let buttonClass="btn-secondary";
    export let showCancel = false;
    export let disabled = false;;
    export let disableBackground = "static";
    export let isButtonLoading = false;
    export let buttonStyle="";
    const dispatch = new createEventDispatcher();      
    const modal = node=> {    

    // the node has been mounted in the DOM  
    jQuery(node).on('shown.bs.modal', function (e) {
      dispatch("show")
    })
    jQuery(node).modal("show");  
    
		return {      
			destroy() {
        // the node has been removed from the DOM
        jQuery(node).modal("hide");
			}
		};
  }
</script>
 


{#if showModal}
<div
class="modal fade {targetClass}"
tabindex="-1"
data-backdrop={disableBackground}
role="dialog"
aria-labelledby="myLargeModalLabel"
aria-hidden="true" style="z-index:{zindex}" use:modal>
<div class="modal-dialog {sizeClass}">
    <div class="modal-content">
        <div class="modal-header">
      <slot name="header"/>
      <button type="button" class="close" data-dismiss="modal" on:click={()=> {showModal = false;dispatch("close")}}>&times;</button>
        </div>
        <div class="modal-body">
         <slot name="content"/>
        </div>
        <div class="modal-footer">
          {#if showCancel}
          <button
          type="button"
          class="btn"          
          data-dismiss="modal"  on:click={()=> {showModal = false;dispatch("close")}}>Cancel</button>
          {/if}
          {#if showConfirmButton} 
        <Button bind:isLoading={isButtonLoading} bind:disabled={disabled} {buttonClass} {buttonText} style={buttonStyle} on:click={()=>dispatch("confirm")}/> 
          <!-- <button
            type="button"
            disabled={disabled ||  isButtonLoading}
          class="btn {buttonClass} {isButtonLoading ? 'is-loading' : ''}"          
          on:click={()=> dispatch("confirm")}>{@html isButtonLoading ?'<i class="fa fa-circle-notch fa-spin"></i> Loading':buttonText}</button> -->
        {/if}
          
        </div>
    </div>
</div>
</div>

{/if}